import React, { useState, useEffect } from "react";
import CategoryContrller from "../../../data/categoryController";
import TableContainer from "../../Table/TableContainer";
import Table from "../../Table/Table";
import TableBody from "../../Table/TableBody";
// import TableHead from "../../Table/TableHead";
import TableCell from "../../Table/TableCell";
import Riders, { timeReleaseStage } from "../../../data/ridersController";
import Select from "../../../UI/Select";
import { nameCustomize } from "../../../util/helper";
import StageController, { GetStage } from "../../../data/stageController";
import { DateDisplay } from "../../../util/helper";
import Modal from "../Modal";
import { Close } from "../../Icons/Icons";
import { Container, Draggable } from "react-smooth-dnd";
// import { GrDrag } from "react-icons/gr";

const ReleaseDraggable = ({ hide }) => {
    const categoryServer = CategoryContrller();
    const ridersParticipants = Riders();
    const stageServer = StageController();
    const [catID, setCatID] = useState(null);
    const [releaseTime, setReleaseTime] = useState("");
    const [interval, setIntervalTime] = useState(30);
    const [currentStage, setCurrentStage] = useState(null);
    const [stageResult, setStageResult] = useState(null);
    const [filteredRiders, setFilteredRiders] = useState([]);


    useEffect(() => {
        if (categoryServer?.length) {
            setCatID(categoryServer[0]);
        }
    }, [categoryServer]);

    useEffect(() => {
        if (stageServer?.length) {
            setCurrentStage(stageServer[0]);
            setStageResult(stageServer[0]?.id);
        }
    }, [stageServer]);

    useEffect(() => {
        console.log("TIMER SeT");
        console.log(ridersParticipants);
        console.log(currentStage);
    
        if (ridersParticipants || currentStage?.id) {
            setFilteredRiders(
                ridersParticipants
                    .filter(rider => rider.category_id === catID?.id)
                    .sort((a, b) => {
                        // Find the stages for the selected `currentStage`
                        const aStage = a.status.find(stage => stage?.stage_id === parseInt(currentStage?.id));
                        const bStage = b.status.find(stage => stage?.stage_id === parseInt(currentStage?.id));
    
                        // If the stage is not found, set a large timestamp instead of Infinity
                        const aTotalTime = aStage ? new Date(aStage?.start_time).getTime() : Number.MAX_VALUE;
                        const bTotalTime = bStage ? new Date(bStage?.start_time).getTime() : Number.MAX_VALUE;
    
                        // Sort based on the totalTime
                        return aTotalTime - bTotalTime;
                    })
            );
        } else {
            setFilteredRiders([]); // Ensure state updates properly when `ridersParticipants` is empty
        }
    }, [catID, stageResult, ridersParticipants, currentStage]); // Ensure dependencies are correctly set
    

    const onDrop = ({ removedIndex, addedIndex }) => {
        if (removedIndex === null || addedIndex === null) return;
        const updatedList = Array.from(filteredRiders);
        const [movedItem] = updatedList.splice(removedIndex, 1);
        updatedList.splice(addedIndex, 0, movedItem);
        console.table(updatedList);
        setTimeout(setFilteredRiders(updatedList),1);
    };


    const handleIntervalChange = (e) => {
        setIntervalTime(Number(e.target.value));
    };

    const setStartTimeRider = () => {
        if (!releaseTime) {
            alert("Please select a start time for the first rider.");
            return;
        }
        timeReleaseStage(filteredRiders, releaseTime, interval, parseInt(currentStage.id), parseInt(catID.id));
        // hide({ success: true });
        alert("Saved.");
    };

    let getStageList = async(id)=>{
        let detailStage = await GetStage(parseInt(id));
        setCurrentStage(detailStage);
        return detailStage;
    };

    let getCategory = (id)=>{
        let category = categoryServer.find(category => category?.id === parseInt(id));
        setCatID(category);
    };

    return (
        <div className="smooth-dnd-parent">
            <Modal withSize={true}>
                <div className="relative">
                    <div className="border-b border-slate-400 w-full flex justify-between p-4">
                        <div className="font-bold text-xl text-yellow-600 flex gap-2">
                            <div>Participants</div>
                        </div>
                        <button onClick={hide} className="mr-6">
                            <Close />
                        </button>
                    </div>
                    <div className="m-2 mx-0 sm:m-4 sm:mx-10 relative flex justify-between flex-wrap">
                        <div className="hidden md:inline flex border rounded-xl overflow-hidden bg-white border-[#d8d8d8] py-1 px-1">
                            {categoryServer && categoryServer.map((cat) => (
                                <button
                                    key={cat.id}
                                    onClick={() => setCatID(cat)}
                                    className={`px-4 py-2 font-medium transition-colors duration-200 capitalize rounded-xl text-xs font-bold ${
                                        catID?.id === cat.id
                                            ? "bg-[#deeeff] text-[#0d6ed1] "
                                            : "text-[#bababa] hover:text-[#0d6ed1]"
                                    }`}
                                >
                                    <div className="font-bold">{cat.name} </div>
                                </button>
                            ))}
                        </div>
                        <Select className="inline md:hidden" items={categoryServer} label="Category" getValue={value=>{getCategory(parseInt(value));}} currentSelect={catID?.id}/> 
                    </div>
                    <div className="flex border m-1 p-1 rounded-md gap-2 items-center flex-col sm:flex-row">
                       
                        <div className="flex items-center gap-2">
                            <div className="hidden sm:inline">
                                Release Time
                            </div>
                            <div>
                                <input className="truncate block py-2.5 px-0 text-sm text-gray-900 bg-transparent focus:border-blue-600 border appearance-none focus:outline-none focus:ring-0 peer rounded-lg px-[15px] disabled:cursor-not-allowed"
                                    type="datetime-local" value={releaseTime} onChange={(e) => setReleaseTime(e.target.value)}/>
                            </div>
                            <div>
                                <label>
                                    <div className="hidden sm:inline">Interval</div>
                                    <select value={interval} onChange={handleIntervalChange}>
                                        <option value={30}>30 sec</option>
                                        <option value={60}>1 min</option>
                                        <option value={90}>1 min 30 sec</option>
                                        <option value={150}>2 min 30 sec</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                        <div className="flex gap-2">
                            <Select items={stageServer} label="Stages" getValue={(value)=>{getStageList(value);}} currentSelect={currentStage?.id}/> 
                            <button className="bg-[#0d6ed1] text-white py-2 px-4 p-2 border rounded-lg text-xs font-bold w-32" onClick={setStartTimeRider}>Set</button>

                        </div> 
                    </div>                    
                    <div className="bg-white rounded-md m-0 sm:m-4 h-[70vh] overflow-y-auto p-0 sm:p-4">
                        
                        <TableContainer>
                            <Table>
                                {/* <thead className="bg-gray-50">
                                    <tr>
                                        {["Rank", "Race #", "Name", "Category"].map((header, key) => (
                                            <TableHead key={key} className="text-center">{header}</TableHead>
                                        ))}
                                    </tr>
                                </thead> */}
                                <TableBody>
                                    <Container groupName="riders" onDrop={onDrop} className="bg-white divide-y divide-gray-200">
                                        {filteredRiders?.map((rider, key) => {
                                            return(
                                                <Draggable key={rider.id} className="cursor-pointer flex">
                                                    <div className='hover:bg-gray-200 flex items-center justify-center' key={key}>
                                                        {/* <TableCell className="py-2 px-2 text-center"> <GrDrag className="text-2xl color-gray dnd-handle cursor-pointer" /></TableCell> */}
                                                        <TableCell className="py-2 px-2 text-center">{key + 1}</TableCell>
                                                        <TableCell className="py-2 px-2 text-center ">{rider.number}</TableCell>
                                                        <TableCell className="py-2 px-2 text-center flex-1">{nameCustomize(rider.name)}</TableCell>
                                                        <TableCell className="py-2 px-2 text-center flex-1">{catID?.name}</TableCell>
                                                        {
                                                            stageServer?.map((serverStg,ind)=>{
                                                                return <TableCell key={ind} className="py-2 px-2 text-[12px] text-center flex-1">
                                                                    {
                                                                        rider?.status?.map((stage,key)=>{
                                                                            return(
                                                                                <> 
                                                                                    {
                                                                                        serverStg.id === stage.stage_id &&
                                                                                            <div key={key} className="flex-row gap-4 items-center justify-center">
                                                                                                {/* <NumberToTime key={key} stages={stage}/> */}
                                                                                                <div className="text-xs">{serverStg.name}</div>
                                                                                                <div className="font-bold cursor-pointer" >{DateDisplay(stage.start_time)}</div>
                                                                                            </div>
                                                                                    }
                                                                                    
                                                                                </>
                                                                            );
                                                                        })
                                                                    }
                                                                </TableCell>;
                                                            })
                                                        }
                                                    </div>
                                                </Draggable>);
                                        })}
                                    </Container>
                                </TableBody>
                            </Table>
                        </TableContainer> 
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ReleaseDraggable;
